import moment from 'moment';
import DTO from './DTO';

class UserActionLogDTO extends DTO {
  constructor(params, isValidInit) {
    const attributes = [
      {
        name: 'causer_id',
        type: String,
        validators: {},
        labelKey: 'userActivityLog.user',
      },
      {
        name: 'date_time',
        type: String,
        validators: {},
        labelKey: 'userActivityLog.date_time',
      },
      {
        name: 'changes_to_object',
        type: String,
        validators: {},
        labelKey: 'userActivityLog.changes_to_object',
      },
      {
        name: 'subject_id',
        type: String,
        validators: {},
        labelKey: 'userActivityLog.subject_id',
      },
      {
        name: 'subject_type',
        type: String,
        validators: {},
        labelKey: 'userActivityLog.subject_type',
      },
    ];

    super(attributes, params, isValidInit);
  }

  getData() {
    return {};
  }
}

export default UserActionLogDTO;
